import { useNavigate } from 'react-router-dom'
import { useOnboarding } from '../../../contexts/OnboardingContext'
import { Building2, Users } from 'lucide-react'

export function ChoosePathStep() {
  const navigate = useNavigate()
  const { nextStep } = useOnboarding()
  
  const handleCreateNew = () => {
    nextStep()
  }
  
  const handleJoinExisting = () => {
    navigate('/onboarding/join')
  }
  
  return (
    <div className="bg-white rounded-lg shadow-sm p-8">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Welcome to ClockinNout
        </h1>
        <p className="text-lg text-gray-600">
          Let's get your team set up for time tracking
        </p>
      </div>
      
      <div className="grid md:grid-cols-2 gap-6">
        <button
          onClick={handleCreateNew}
          className="group relative p-6 bg-white border-2 border-gray-200 rounded-lg hover:border-blue-500 hover:shadow-md transition-all"
        >
          <div className="flex flex-col items-center text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-200 transition-colors">
              <Building2 className="w-8 h-8 text-blue-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Create new company
            </h3>
            <p className="text-gray-600">
              Start fresh with your own company or team
            </p>
          </div>
        </button>
        
        <button
          onClick={handleJoinExisting}
          className="group relative p-6 bg-white border-2 border-gray-200 rounded-lg hover:border-blue-500 hover:shadow-md transition-all"
        >
          <div className="flex flex-col items-center text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-green-200 transition-colors">
              <Users className="w-8 h-8 text-green-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Join existing company
            </h3>
            <p className="text-gray-600">
              Request to join a company already using ClockInNOut
            </p>
          </div>
        </button>
      </div>
    </div>
  )
}

export default ChoosePathStep